import { MAPTILER_KEY, MIN_ADDRESS_LENGTH } from "./constants";
import type { GeocodingFeature } from "./types";

async function searchAddress({
	query,
	signal,
	relevanceCenter,
}: {
	query: string;
	signal?: AbortSignal;
	relevanceCenter?: [number, number];
}): Promise<Array<GeocodingFeature>> {
	if (query.trim().length < MIN_ADDRESS_LENGTH) {
		return [];
	}

	const relevanceCenterParam = relevanceCenter !== undefined ? `&proximity=${relevanceCenter[0]},${relevanceCenter[1]}` : "";
	const url = `https://api.maptiler.com/geocoding/${encodeURIComponent(query)}.json?key=${MAPTILER_KEY}&limit=5&language=pl${relevanceCenterParam}`;
	const response = await fetch(url, { signal });

	if (response.ok === false) {
		throw new Error(`Geocoding failed: ${response.status}`);
	}

	const data = await response.json();
	const features = data.features ?? [];

	return features.map((f: { id: string; place_name: string; center: [number, number] }) => ({
		id: f.id,
		name: f.place_name,
		center: f.center,
	}));
}

export { searchAddress };
